import storage from '@/lib/storage';
import DashboardContainer from './main-dashboard/Dashboard';

export default function Dashboard() {
    const userData = storage.getUserData();
    const isSuperUser = userData?.isSuperuser
    return (
        <div className="bg-gray-50">
            <main className="max-w-7xl">
                   <DashboardContainer isSuperUser={isSuperUser}/>
            </main>
        </div>
    )
}
